// extracted by mini-css-extract-plugin
export default {"button":"NewButton_button__2q5I6","fullWidth":"NewButton_fullWidth__3hEEB","disabled":"NewButton_disabled__XPU1t","loader":"NewButton_loader__SjzKP","spin":"NewButton_spin__Pw15J"};